import React from 'react';
import PropTypes from 'prop-types';
import NavItem from 'Components/nav-item/NavItem.jsx';
import HomeIcon from 'Components/icons/HomeIcon';
import QueuesIcon from 'Components/icons/QueuesIcon';
import SearchIcon from 'Components/icons/SearchIcon';
import OpenFolderIcon from 'Components/icons/OpenFolderIcon/OpenFolderIcon';
import CaseIcon from 'Components/icons/CaseIcon/CaseIcon';
import ReportsIcon from 'Components/icons/ReportsIcon';
import SettlementIcon from 'Components/icons/SettlementIcon';
import OperationsIcon from 'Components/icons/OperationsIcon';
import {
  Tooltip,
} from 'react-tippy';
import RecentCaseView from 'Components/RecentCaseView/RecentCaseView';

import 'react-tippy/dist/tippy.css';
import { getAcquirerAccessList } from 'Utils/permissionsUtils';

import CustomQueueAdminIcon from 'Components/icons/CustomQueueAdminIcon';
import CustomQueueIcon from 'Components/icons/CustomQueueIcon';
import ProductivityReportIcon from 'Components/icons/ProductivityReportIcon';
import FileImportIcon from '../../../../dims-common-ui/components/icons/FileImportIcon';

const PrimaryNavigation = (props) => {
  const tipEnabled = props.navCollapsed === 'expanded';
  const reportsSubNav = [];
  let acquirerList = getAcquirerAccessList();
  reportsSubNav.push({ label: 'Settlement Reports', route: '/reports/settlement', icon: <SettlementIcon /> });
  props.user !== undefined && props.user.parsedPermissions.queue.viewInternalReports && reportsSubNav.push({ label: 'Operations Reports', route: '/reports/operations', icon: <OperationsIcon /> });
  props.user !== undefined && props.user.parsedPermissions.queue.viewProductivityReport && reportsSubNav.push({ label: 'Productivity Report', route: '/reports/productivityreport', icon: <ProductivityReportIcon /> });
  props.user !== undefined && props.user.parsedPermissions.queue.viewProductDashboard && reportsSubNav.push({ label: 'Product Reports', route: '/reports/productreport', icon: <OperationsIcon /> });
  const role = props?.user?.role?.key;
  const internalEmployees = ['DiMS_INTERNAL_EMPLOYEE'];
  const fileImportPermittedUsers = ['DiMS_DISPUTE_MANAGER', 'DiMS_PRODUCTION_SUPPORT', 'DiMS_DISPUTE_PRODUCT_MANAGER'];
  let isInternalUser = false
  let isfileImportPermittedUsers = false;
  if (fileImportPermittedUsers.findIndex((userRole) => userRole === role) !== -1) {
    isfileImportPermittedUsers = true;
  }

  // Determine the route based on user permissions
  const getRoute = () => {
    const { createQueue, viewUnresolvedRTIReport } = props.user.parsedPermissions.queue;

    if (createQueue) {
      return "/customQueue";
    } else if (viewUnresolvedRTIReport) {
      return "/unresolve";
    } else {
      return "/fileImport";
    }
  };

  // Determine the forceIsActive value based on the current URL
  const getForceIsActive = () => {
    const validPaths = ["unresolve", "customQueue", "fileImport"];
    const currentPath = window.location.href.split("/")[4];

    if (validPaths.includes(currentPath)) {
      return currentPath;
    } else {
      return "";
    }
  };

  // Compute route and forceIsActive values
  const adminSubmenuRoute = getRoute();
  const adminSubmenuforceIsActive = getForceIsActive();

  const adminSubNav = [];
  props.user !== undefined && props.user.parsedPermissions.queue.createQueue &&
    adminSubNav.push({ label: 'Custom Queues', route: '/customQueue', icon: <CustomQueueIcon /> });

  if (props.user !== undefined && props.user.parsedPermissions.queue.viewUnresolvedRTIReport) {
    adminSubNav.push({ label: 'Unresolve', route: '/unresolve', icon: <OperationsIcon /> });
  }
  if (props.user !== undefined && isfileImportPermittedUsers) {
    adminSubNav.push({ label: 'File Import', route: '/fileImport', icon: <FileImportIcon /> });
  }


  const insightsSubNav = [];
  props.user !== undefined && props.user.parsedPermissions.queue.seeStatsForQueue &&
    insightsSubNav.push({ label: 'Insights', route: '/insights', icon: <CustomQueueIcon /> });

  if (internalEmployees.findIndex(internalEmp => internalEmp == role) != -1) {
    isInternalUser = true;
  }
  return (
    <div className="flexNav scrollable-container">
      <div>
        <ul className={props.verticalNavClasses}>

          {!isInternalUser && <Tooltip
            title="Dashboard"
            position="right"
            size="big"
            trigger="mouseenter"
            className="nav-tooltip"
            disabled={tipEnabled}
          >
            <NavItem
              triggerSubNav={(event) => props.triggerSubNav(event)}
              route="/dashboard"
              navActionClasses={props.navActionClasses}
              activeClassName="vertical-nav-action vertical-nav-action-active"
              iconClasses={props.iconClasses}
              icon={<HomeIcon />}
              labelClasses={props.labelClasses}
              navLabel="Dashboard"
            />
          </Tooltip>}


          {!isInternalUser && <Tooltip
            title="Reports"
            position="right"
            size="big"
            trigger="mouseenter"
            className="nav-tooltip"
            disabled={tipEnabled}
          ><NavItem
              triggerSubNav={(event) => props.triggerSubNav(event)}
              forceIsActive={window.location.href.split("/reports/")[1] == "productivityreport"
                ? "productivityreport" : "operations"}
              route="/reports/settlement"
              navActionClasses={props.navActionClasses}
              activeClassName="vertical-nav-action vertical-nav-action-active"
              iconClasses={props.iconClasses}
              icon={<ReportsIcon />}
              labelClasses={props.labelClasses}
              navLabel="Reports"
              subNav={reportsSubNav}
            /></Tooltip>}

          {!isInternalUser && props.user !== undefined && props.user.parsedPermissions.queue.canViewAll &&
            <Tooltip
              title="Queues"
              position="right"
              size="big"
              trigger="mouseenter"
              className="nav-tooltip"
              disabled={tipEnabled}
            >
              <NavItem
                triggerSubNav={(event) => props.triggerSubNav(event)}
                route="/landing"
                navActionClasses={props.navActionClasses}
                activeClassName="vertical-nav-action vertical-nav-action-active"
                iconClasses={props.iconClasses}
                icon={<QueuesIcon />}
                labelClasses={props.labelClasses}
                navLabel="Queues"
                forceIsActive="insights"
                subNav={insightsSubNav}
              />
            </Tooltip>
          }

          {!isInternalUser && (acquirerList.length !== 0 || !props.user.parsedPermissions.queue.canViewAll) &&
            <Tooltip
              title="My Cases"
              position="right"
              size="big"
              trigger="mouseenter"
              className="nav-tooltip"
              disabled={tipEnabled}
            >
              <NavItem
                triggerSubNav={(event) => props.triggerSubNav(event)}
                forceIsActive="queueid=69"
                route="/queue-management-landing?queueid=69&hideDropdown=true"
                navActionClasses={props.navActionClasses}
                activeClassName="vertical-nav-action vertical-nav-action-active"
                iconClasses={props.iconClasses}
                icon={<OpenFolderIcon />}
                labelClasses={props.labelClasses}
                navLabel="My Cases"
              />
            </Tooltip>}

          {
            props.user && props.user.parsedPermissions &&
            props.user.parsedPermissions.case.viewCaseSearch
            && (acquirerList.length !== 0 || !props.user.parsedPermissions.queue.canViewAll && props.user.role.name !== "Tech Support Admin") &&
            (

              <Tooltip
                title="Case Search"
                position="right"
                size="big"
                trigger="mouseenter"
                className="nav-tooltip"
                disabled={tipEnabled}
              >
                <NavItem
                  triggerSubNav={(event) => props.triggerSubNav(event)}
                  route="/casesearch"
                  navActionClasses={props.navActionClasses}
                  activeClassName="vertical-nav-action vertical-nav-action-active"
                  iconClasses={props.iconClasses}
                  icon={<SearchIcon />}
                  labelClasses={props.labelClasses}
                  navLabel="Case Search"
                />
              </Tooltip>

            )
          }

          {!isInternalUser && props.user && props.user.parsedPermissions
            && (props.user.parsedPermissions.queue.createQueue || props.user.parsedPermissions.queue.viewUnresolvedRTIReport
              || isfileImportPermittedUsers) &&
            <Tooltip
              title="Admin"
              position="right"
              size="big"
              trigger="mouseenter"
              className="nav-tooltip"
              disabled={tipEnabled}
            >
              <NavItem
                triggerSubNav={(event) => props.triggerSubNav(event)}
                route={adminSubmenuRoute}
                forceIsActive={adminSubmenuforceIsActive}
                navActionClasses={props.navActionClasses}
                activeClassName="vertical-nav-action vertical-nav-action-active"
                iconClasses={props.iconClasses}
                icon={<CustomQueueAdminIcon />}
                labelClasses={props.labelClasses}
                navLabel="Admin"
                subNav={adminSubNav}
              /></Tooltip>}

          {/* THIS IS AN EXAMPLE OF A NAV ITEM THAT HAS A SUBNAV

        <NavItem
          triggerSubNav={(event) => props.triggerSubNav(event)}
          route="/caselanding"
          navActionClasses={props.navActionClasses}
          activeClassName="vertical-nav-action vertical-nav-action-active"
          iconClasses={props.iconClasses}
          icon={<ReportsIcon />}
          labelClasses={props.labelClasses}
          navLabel="Reports"
          subNav={reportsSubNav}
        /> */}



          {!isInternalUser && <div className={props.navCollapsed === 'expanded' ? 'open-cases expanded' : 'open-cases collapsed'}>
            <NavItem
              className="open-cases"
              route="#"
              navActionClasses={props.navActionClasses}
              activeClassName="vertical-nav-action"
              iconClasses={props.iconClasses}
              icon={<CaseIcon />}
              labelClasses={props.labelClasses}
              navLabel={props.transitionEnded && ''}
            />
            <div className="recent-case-view">
              <RecentCaseView
                recentCasesList={props.recentCases}
                navActionClasses={props.navActionClasses}
                labelClasses={props.labelClasses}
                transitionEnded={props.transitionEnded}
                unlockCurrentCase={props.unlockCurrentCase}
                unlockAllCurrentCases={props.unlockAllCurrentCases}
              />
            </div>
          </div>}
        </ul>
      </div>
    </div >
  );
};

PrimaryNavigation.propTypes = {
  iconClasses: PropTypes.string,
  labelClasses: PropTypes.string,
  messages: PropTypes.object.isRequired,
  reportList: PropTypes.array,
  navActionClasses: PropTypes.string,
  subNavTriggered: PropTypes.bool.isRequired,
  triggerSubNav: PropTypes.func,
  transitionEnded: PropTypes.bool.isRequired,
  verticalNavClasses: PropTypes.string,
  recentCases: PropTypes.array.isRequired,
  navCollapsed: PropTypes.string,
  unlockCurrentCase: PropTypes.func,
  unlockAllCurrentCases: PropTypes.func,
};

PrimaryNavigation.defaultProps = {
  recentCases: [],
  iconClasses: 'vertical-nav-icon',
  labelClasses: 'vertical-nav-label',
  navActionClasses: 'vertical-nav-action',
  triggerSubNav: () => { },
  verticalNavClasses: 'vertical-nav',
  navCollapsed: 'expanded',
};

export default PrimaryNavigation;
